var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedCheckbox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 1.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.38746 9.22917C1.87085 8.69282 1.87085 7.82322 2.38746 7.28687C2.90408 6.75052 3.74169 6.75052 4.25831 7.28687L5.94207 9.03494C6.04539 9.14221 6.21292 9.14221 6.31624 9.03494L11.7417 3.40226C12.2583 2.86591 13.0959 2.86591 13.6125 3.40226C14.1292 3.93862 14.1292 4.80821 13.6125 5.34457L6.31624 12.9195C6.21292 13.0268 6.04539 13.0268 5.94207 12.9195L2.38746 9.22917Z",
    fill: "#743BBC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 1.5,
    stroke: "#E5E7EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCheckbox);
export default __webpack_public_path__ + "static/media/checkedCheckbox.19b74c0042e48fa65574e661799f0db7.svg";
export { ForwardRef as ReactComponent };